import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { ControlLabel, FormGroup } from 'react-bootstrap';

class HtmlInfo extends Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    var input = null;
    var readOnly = null;

    if(this.props.readOnly && this.props.value != null) {
      input = null;
      readOnly = (
          <div 
              className="htmlInfo" 
              dangerouslySetInnerHTML={{__html: this.props.value}}
            >
          </div>
      );
    }

    if(this.props.value != null)
        return (
          <div id={this.props.id} className={this.props.className}>
            <FormGroup>
              <ControlLabel>{this.props.label}</ControlLabel>
              {readOnly}
              {input}
            </FormGroup>
          </div>
        );
    return null;
  }
}

HtmlInfo.propTypes = {};

export default HtmlInfo;



// WEBPACK FOOTER //
// ./source/client/components/tasks_manager/form_components/htmlInfo.jsx